// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MultilingualString
 */
export interface MultilingualString {
  /**
   *
   */
  _default: string | null;
}

/**
 * Check if a given object implements the MultilingualString interface.
 */
export function instanceOfMultilingualString(value: object): value is MultilingualString {
  if (
    (!("_default" in (value as Record<string, any>)) &&
      !("default" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["_default"] === undefined &&
      (value as Record<string, any>)["default"] === undefined)
  )
    return false;
  return true;
}

export function MultilingualStringFromJSON(json: any): MultilingualString {
  return MultilingualStringFromJSONTyped(json, false);
}

export function MultilingualStringFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MultilingualString {
  if (json == null) {
    return json;
  }
  return {
    _default: json["default"],
  };
}

export function MultilingualStringToJSON(json: any): MultilingualString {
  return MultilingualStringToJSONTyped(json, false);
}

export function MultilingualStringToJSONTyped(
  value?: MultilingualString | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    default: value["_default"],
  };
}
